<template>
  <div @click="showChangeCoordinator" class="info-item" id="project__list__coordinator">
    <span class="text-uppercase exclude-outside-click field-label cursor-pointer">{{ coordinatorFieldLabel(project) }}</span>
    <div class="info-bubbles exclude-outside-click">
      <span
        class="initials badge badge-primary cursor-pointer exclude-outside-click"
        v-b-tooltip.hover.html
        v-for="(fieldValue, index) in project.projectCoordinators"
        :title="(index < 3) ? fieldValue.name : getTitle(project.projectCoordinators)"
        v-if="index<=3"
      >
        <span class="exclude-outside-click" v-if="index<3">{{fieldValue.name | textInitials}}</span>
        <span class="exclude-outside-click" v-if="index==3">+{{ project.projectCoordinators.length-index }}</span>
      </span>
      <span class="badge badge-gray exclude-outside-click cursor-pointer" v-if="!project.projectCoordinators">No Coordinator</span>
      <plus-button v-show="!addCoordinatorFlag" class="tagged-contacts plus-button plus-button--small"></plus-button>
    </div>
    <div v-show="addCoordinatorFlag" class="add-multiselect-group">
      <div class="custom-field user-field custom-multiselect">
        <multiselect
          ref="projectListCoordinators"
          v-model="project.projectCoordinators"
          v-click-outside="outside"
          :options="allUsers"
          :show-labels="true"
          :multiple="true"
          :allow-empty="false"
          open-direction="bottom"
          label="name"
          track-by="id"
          @close="addCoordinatorFlag=false"
          @input="updateProjectFieldValue(projectCoordinatorField); addCoordinatorFlag = false"
        ></multiselect>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["project"],
  data() {
    return {
      addCoordinatorFlag: false,
      projectCoordinator: [],
      projectCoordinatorField: ''
    };
  },
  computed: {
    ...mapGetters(["allUsers", "userAbilities"]),
  },
  methods: {
    ...mapActions(["updateProjectFieldValue"]),
    getTitle(coordinators) {
      let title = '';
      coordinators.forEach((coordinator, index) => {
        if(index >= 3) {
          title += coordinator.name+'<br>';
        }
        return title
      });
      return title;
    },
		coordinatorFieldLabel(project) {
			let data = _.filter(project.customFields, {field_key: 'project_coordinator'});
			return data.length > 0 ? data[0].label : 'Coordinator';
		},
    outside() {
      this.$set(this, "addCoordinatorFlag", false);
    },
    showChangeCoordinator() {
      // if(!this.userAbilities.editMediaCall || this.deliverable.permissions.viewOnly) return;
      this.addCoordinatorFlag = true;
      this.$nextTick(() => {
        this.$refs.projectListCoordinators.$el.focus();
      });
    }
  },
  mounted() {
    let data = _.filter(this.project.customFields, {field_key: 'project_coordinator'});
    if(data.length > 0 && typeof data[0].value == 'string') {
      data[0].value = JSON.parse(data[0].value);
      this.projectCoordinatorField = data[0];
    }
  }
};
</script>

<style>
</style>